export default "__VITE_ASSET__ad58ce72__"